import { computed } from "vue";
import { useI18n } from "vue-i18n";
// import { debounce } from "lodash";

// export { debounce };

export const useI18nMixin = () => useI18n({ useScope: "global" });
export function translateComputed(key: string, keys?: object) {
  const { t } = useI18n({ useScope: "global" });
  return computed(() => t(key, { ...keys }));
}

export function translate(key: string, keys?: object) {
  const { t } = useI18n({ useScope: "global" });
  return t(key, { ...keys });
}


export function formatDateString(
  dateString: string | null,
): ComputedRef<string> | string {
  if (dateString === null) {
    return "-";
  }
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return translate("employee.validation.notValid");
  }

  // Format the date as needed (e.g., 'YYYY-MM-DD')
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

/**
 * Checks if the given value is an empty array.
 *
 * @param value - The value to check, expected to be an array or any type.
 * @returns True if the value is an empty array, false otherwise.
 */
export function isEmptyArray(value: unknown): value is unknown[] {
  return Array.isArray(value) && value.length === 0;
}
/**
 * Checks if the given value is null or undefined.
 *
 * @param value - The value to check.
 * @returns True if the value is null or undefined, false otherwise.
 */
export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

/**
 * Checks if the given value is empty.
 *
 * @param value - The value to check.
 * @returns True if the value is empty, false otherwise.
 */
export function isEmpty(value: any): boolean {
  if (value === null || value === undefined) return true;

  if (typeof value === "string") return value.trim().length === 0;

  if (Array.isArray(value)) return value.length === 0;

  if (typeof value === "object") return Object.keys(value).length === 0;

  return false;
}

// 👉 IsObject
export const isObject = (obj: unknown): obj is Record<string, unknown> =>
  obj !== null && !!obj && typeof obj === "object" && !Array.isArray(obj);

export const isToday = (date: Date) => {
  const today = new Date();

  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};
